module.exports = __webpack_public_path__ + "img/band(4).6afd0f9e.jpg";